var jquery = require("jquery");
var cookie = require("jquery.cookie");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;


// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	$("[data-required]").each(function (index) {
		$(this).attr('required', true);
	});

	tooltipsPosition();

	if ($('[data-results-grid]').length) {
		setTimeout(() => {
			tooltipsPosition();
		}, 1500);
	}

	// QUIZES IN LESSONS
	var quizBlocks = $('.quiz-block');
	quizBlocks.each(function() {
		var uid = $(this).attr('data-quiz');
		fetchQuizData(uid, 'quiz-preview');
	})

	// AUDIO
	pollyPlayButtonInit();

	// THINGLINK
	// var script = document.createElement('script');
	// script.src = 'https://cdn.thinglink.me/jse/responsive.js';
	// document.head.appendChild(script);

});


// SCROLL

$(window).on('scroll', function(e) {


	var scrollTop = $(window).scrollTop();


});


// RESIZE

$(window).on('resize', function() {

	tooltipsPosition();

});


$('[data-scroll-up]').on('click', function() {
	$('html, body').animate({scrollTop: 0}, 'slow');
});

$(document).on('click', '.tooltip[aria-title]', function(e) {
	if (!isTouchDevice()) {
		return;
	}
	var tooltips = $('.tooltip[aria-title]');
	if (!$(this).hasClass('active')) {
		tooltips.removeClass('active');
		$(this).addClass('active');
	} else {
		tooltips.removeClass('active');
		$(this).removeClass('active');
	}
});
$('body').on('click', function(event) {
	if (!isTouchDevice()) {
		return;
	}
	var tooltips = $('.tooltip[aria-title]');
	if (!$(event.target).hasClass('tooltip')) {
		tooltips.removeClass('active');
	}
});

function tooltipsPosition() {
	var tooltips = $('.tooltip[aria-title]');
	if (tooltips.length) {
		
		tooltips.each(function() {
			// console.log($(this))
			if (checkElementPosition($(this)) === 'left') {
				$(this).addClass('tooltip-left');
			} else {
				$(this).removeClass('tooltip-left');
			}
			if (checkElementPosition($(this)) === 'right') {
				$(this).addClass('tooltip-right');
			} else {
				$(this).removeClass('tooltip-right');
			}
		})
	}
}

function isTouchDevice() {
	return (('ontouchstart' in window) ||
	   (navigator.maxTouchPoints > 0) ||
	   (navigator.msMaxTouchPoints > 0));
}


function checkElementPosition(el) {
	var $element = el;
	var windowWidth = $(window).width();

	if (windowWidth >= 640) {
		var tooltipMaxW = 400;
	} else {
		var tooltipMaxW = windowWidth * 0.8;
	}
	var elementWidth = $element.outerWidth();
	var tooltipLeft = $element.offset().left + elementWidth/2 - tooltipMaxW/2;
	var tooltipRight = $element.offset().left + elementWidth/2 + tooltipMaxW/2;
	
	// Check if the element is going over the left edge
	// console.log('tooltipLeft ' + tooltipLeft)
	// console.log('tooltipRight ' + tooltipRight)
	if (tooltipLeft < 0) {
		// console.log('Element is going over the left edge.');
		return 'left';
	}
	// console.log(windowWidth - elementPosition + elementWidth)
	// // Check if the element is going over the right edge
	if (tooltipRight > windowWidth) {
		// console.log('Element is going over the right edge.');
		return 'right';
	}
}















///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// AUDIO

var data = {};

$(document).on('click', '[data-polly][data-playing="false"] .icon', function(e) {
	var dataPollyEl = $(this).parent();
	var dataPollyNode = this.parentNode;
	var audioElement = dataPollyNode.querySelector('audio');
	var currentTimeEl = dataPollyEl.find('.current-time');
	var totalTimeEl = dataPollyEl.find('.total-time');

	$('[data-polly][data-playing="true"]').attr('data-playing', 'false');
	$('[data-polly] audio').attr('src', '');

	data['audioFilename'] = dataPollyEl.attr('data-audio-filename');
	data['text'] = dataPollyEl.attr('data-raw-text');
	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
	console.log(data)
	dataPollyEl.attr('data-playing','loading');
	$.ajax({
		type: 'post',
		url: '/actions/polly/polly/audio-exists',
		data: data,
		success: function (response) {
			console.log(response);
			var success = response.success;
			if (success) {
				console.log('y')
				console.log(dataPollyEl)
				audioElement.src = response.fileUrl;
				dataPollyEl.attr('data-playing','true');
				dataPollyEl.find('.audio-player .controls .player-button').trigger('click');
				console.log('audioElement');
				console.log(audioElement);
				audioElement.addEventListener('timeupdate', function() {
					currentTimeEl.html(formatTime(audioElement.currentTime));
					totalTimeEl.html(formatTime(audioElement.duration));
					var progress = (audioElement.currentTime / audioElement.duration) * 100;
					if (progress) {
						console.log('progress ' + progress)
						if (progress >= 100) {
							dataPollyEl.attr('data-playing','false');
						}
					}
				});

			} else {
				console.log('n')
				$.ajax({
					type: 'post',
					url: '/actions/polly/polly/play-text',
					data: data,
					success: function (response) {
						console.log('PLAY TEXT')
						console.log(response);
						audioElement.src = response.fileUrl;
						dataPollyEl.attr('data-playing','true');
						dataPollyEl.find('.audio-player .controls .player-button').trigger('click');
						audioElement.addEventListener('timeupdate', function() {
							currentTimeEl.html(formatTime(audioElement.currentTime));
							totalTimeEl.html(formatTime(audioElement.duration));
							var progress = (audioElement.currentTime / audioElement.duration) * 100;
							if (progress) {
								console.log('progress ' + progress)
								if (progress >= 100) {
									dataPollyEl.attr('data-playing','false');
								}
							}
						});
					},
					error: function (response) {
						console.log(response);
					}
				});
			}
		},
		error: function (response) {
			console.log(response);
		}
	});

	return true;

});


const playIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#0A0A0A">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd" />
    </svg>
  `;
const pauseIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#0A0A0A">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
    </svg>
  `;
const soundIcon = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#0A0A0A">
		<path fill-rule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z" clip-rule="evenodd" />
	</svg>`;
const muteIcon = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#0A0A0A">
		<path fill-rule="evenodd" d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z" clip-rule="evenodd" />
	</svg>`;
const scrollUpIcon = `
	<svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65">
		<g transform="translate(-1594 -6991)">
		<g transform="translate(1594 6991)" fill="none" stroke="#fff" stroke-width="1.5">
		<circle cx="32.5" cy="32.5" r="32.5" stroke="none"></circle>
		<circle cx="32.5" cy="32.5" r="31.75" fill="none"></circle>
		</g>
		<g transform="translate(1616.131 7011.881)">
		<line x2="24.43" transform="translate(10.989 24.488) rotate(-90)" fill="none" stroke="#fff" stroke-width="2"></line>
		<path d="M15.883.342l.342,15.882L.342,15.882" transform="translate(10.989 22.945) rotate(-135)" fill="none" stroke="#fff" stroke-width="2"></path>
		</g>
		</g>
	</svg>`;

function pollyPlayButtonInit() {
	$('.player-button').each(function() {
		var playerButton = $(this);
		var container = playerButton.parent().parent();
		if (container.length > 0) {
			var audio = container.find('audio');
			var timeline = container.find('.timeline');
			var soundButton = container.find('.sound-button');

			function toggleAudio() {
				if (audio[0].paused) {
					audio[0].play();
					playerButton.html(pauseIcon);
				} else {
					audio[0].pause();
					playerButton.html(playIcon);
				}
			}

			playerButton.on('click', toggleAudio);

			function changeTimelinePosition() {
				var percentagePosition = (100 * audio[0].currentTime) / audio[0].duration;
				timeline.css('background-size', percentagePosition + '% 100%');
				timeline.val(percentagePosition);
			}

			audio.on('timeupdate', changeTimelinePosition);

			function audioEnded() {
				playerButton.html(playIcon);
			}

			audio.on('ended', audioEnded);

			function changeSeek() {
				var time = (timeline.val() * audio[0].duration) / 100;
				audio[0].currentTime = time;
			}

			timeline.on('change', changeSeek);

			function toggleSound() {
				audio[0].muted = !audio[0].muted;
				soundButton.html(audio[0].muted ? muteIcon : soundIcon);
			}

			soundButton.on('click', toggleSound);
		}
	});
}

// const playerButtons = document.querySelectorAll('.player-button');

// playerButtons.forEach(playerButton => {
// 	const container = playerButton.parentNode.parentNode;
// 	if (container) {
// 		const audio = container.querySelector('audio'),
// 		timeline = container.querySelector('.timeline'),
// 		soundButton = container.querySelector('.sound-button');

// 		function toggleAudio() {
//             console.log('toggleAudio')
//             console.log(audio)
// 			if (audio.paused) {
// 				audio.play();
// 				playerButton.innerHTML = pauseIcon;
// 			} else {
// 				audio.pause();
// 				playerButton.innerHTML = playIcon;
// 			}
// 		}

// 		playerButton.addEventListener('click', toggleAudio);

// 		function changeTimelinePosition() {
// 			const percentagePosition = (100 * audio.currentTime) / audio.duration;
// 			timeline.style.backgroundSize = `${percentagePosition}% 100%`;
// 			timeline.value = percentagePosition;
// 		}

// 		audio.ontimeupdate = changeTimelinePosition;

// 		function audioEnded() {
// 			playerButton.innerHTML = playIcon;
// 		}

// 		audio.onended = audioEnded;

// 		function changeSeek() {
// 			const time = (timeline.value * audio.duration) / 100;
// 			audio.currentTime = time;
// 		}

// 		timeline.addEventListener('change', changeSeek);

// 		function toggleSound() {
// 			audio.muted = !audio.muted;
// 			soundButton.innerHTML = audio.muted ? muteIcon : soundIcon;
// 		}

// 		soundButton.addEventListener('click', toggleSound);
// 	}
// });


function formatTime(time) {
	var minutes = Math.floor(time / 60);
	var seconds = Math.floor(time % 60);
	return pad(minutes) + ':' + pad(seconds);
}

function pad(number) {
	return (number < 10 ? '0' : '') + number;
}









///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ATTEMPTS COUNTER
window.countAttempt = function countAttempt(reload = false) {
	var data = {};
	if (reload) {
		var quizBtnCol = window.parent.$('.column-quiz-iframe-show');
		var quizIframe = window.parent.$('iframe[data-quiz-iframe]');
		var body = window.parent.$('body');
	} else {
		var quizBtnCol = window.$('.column-quiz-iframe-show');
		var quizIframe = $('iframe[data-quiz-iframe]');
		var body = $('body');
	}

	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
	console.log('ATTEMPTS COUNTER')
	console.log(data)
	$.ajax({
		type: 'post',
		url: '/actions/lesson/student/count-attempt',
		data: data,
		success: function (response) {
			console.log(response);
			var success = response.success;
			var attempt = response.attempt;
			var attemptsExceeded = response.attemptsExceeded;
			if (success) {
				// console.log('y')
				// console.log('attempt ' + attempt)
				if (attempt >= 2) {
					quizBtnCol.html('<div class="btn btn-fill btn-black btn-quiz-completed">Quiz completed</div>');
					$('[data-modal-activities]').before('<div data-activities-open-btn class="btn btn-fill btn-yellow btn-activities">Activities</div>');
				}
				if (attemptsExceeded) {
					quizBtnCol.html('<div class="btn btn-fill btn-black btn-quiz-completed">Quiz completed</div>');
					quizIframe.remove();
					body.attr('data-quiz-expanded', false);
					$('[data-modal-activities]').before('<div data-activities-open-btn class="btn btn-fill btn-yellow btn-activities">Activities</div>');
				}
				if (reload) {
					location.reload();
				} else {

				}
			} else {
				console.log('n')
			}
		},
		error: function (response) {
			console.log(response);
		}
	});

	return true;
}






///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CREATE LIVE LESSON
var data = {};

$(document).on('click', '[data-create-live-code]', function(e) {
	var btn = $(this);
	var uid = btn.attr('data-lesson-uid');
	data['uid'] = uid;
	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
	var btnText = $(this).text();
	$.ajax({
		type: 'post',
		url: '/actions/lesson/lesson/create-live-lesson',
		data: data,
		success: function (response) {
			console.log(response);
			var success = response.success;
			if (success) {
				console.log('y')
				
				if (dataLayer) {
					dataLayer.push({
						'event': 'create_code',
						'teacherEmail': response.teacherEmail,
						'lessonTitle': response.lessonTitle,
						'lessonCode': response.lessonCode ?? ''
					});
				}

				if ($('body.account').length) {
					var postAction = btn.attr('data-post-action');
					if (postAction == 'refresh-live-lessons') {
						fetchLiveLessonsData();
					}

				} 

				var lessonPopup = false;
				if (response.lessonType == 'lesson') {
					lessonPopup = siteUrl + '/code/' + response.liveLessonUID;
					// console.log('lessonPopup ' + lessonPopup)
				}
				if (response.lessonType == 'mini') {
					lessonPopup = siteUrl + '/' + response.liveLessonUID;
					if ($('[data-lesson-popup-close]').length) {
						$('[data-lesson-popup-close]').trigger('click');
					}
					// console.log('lessonPopup ' + lessonPopup)
				}
				if (lessonPopup) {
					var newWindow = window.open("", "_blank");
					if (newWindow) {
						newWindow.location.href = lessonPopup;
					} else {
						alert("Pop-up blocked. Please enable pop-ups for this website.");
					}             
				}

				btn.text('Created!');
			
				setTimeout(() => {
					btn.text(btnText);
				}, 1500);

			} else {
				console.log('n')
			}
		},
		error: function (response) {
			console.log(response);
		}
	});

	return true;

});





///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// REMOVE LESSON
var data = {};
$(document).on('click', '[data-remove-lesson]', function(e) {
	var btn = $(this);
	var uid = btn.attr('data-lesson-uid');
	var postAction = btn.attr('data-post-action');
	$('[data-lesson-remove-message]').attr('data-visible', 'true')
	$('[data-lesson-remove-confirm]').attr('data-post-action', postAction)
	$('[data-lesson-remove-confirm]').attr('data-lesson-uid', uid)

	return true;

});
$(document).on('click', '[data-lesson-remove-cancel]', function(e) {
	$('[data-lesson-remove-message]').attr('data-visible', 'false')
	$('[data-lesson-remove-confirm]').attr('data-post-action', '')
	$('[data-lesson-remove-confirm]').attr('data-lesson-uid', '')

	return true;

});
$(document).on('click', '[data-lesson-remove-confirm]', function(e) {
	var btn = $(this);
	var uid = btn.attr('data-lesson-uid');
	data['uid'] = uid;
	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
	console.log(data)
	$.ajax({
		type: 'post',
		url: '/actions/lesson/lesson/remove-lesson',
		data: data,
		success: function (response) {
			console.log(response);
			var success = response.success;
			if (success) {
				console.log('y')
				if ($('body.account').length) {
					if (btn.attr('data-post-action') == 'refresh-recent-lessons-mini') {
						fetchRecentLessonsData('mini');
					} else {
						fetchRecentLessonsData('full');
					}
				} else {

				}

			} else {
				console.log('n')
			}
			$('[data-lesson-remove-message]').attr('data-visible', 'false')
		},
		error: function (response) {
			console.log(response);
		}
	});

	return true;

});








///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DOWNLOAD RESULTS
var data = {};
$(document).on('click', '[data-download-results]', function(e) {
	var btn = $(this);
	var uid = btn.attr('data-lesson-uid');
	btn.addClass('loading');
	data['uid'] = uid;
	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
	console.log(data)
	$.ajax({
		type: 'post',
		url: '/actions/lesson/lesson/download-results',
		data: data,
		success: function (response) {
			console.log(response);
			var success = response.success;
			if (success) {
				console.log('y')
				console.log(response.fileUrl)
				var newWindow = window.open("", "_blank");
				if (newWindow) {
					newWindow.location.href = response.fileUrl;
				} else {
					alert("Pop-up blocked. Please enable pop-ups for this website.");
				}             
			} else {
				console.log('n')
			}
			btn.removeClass('loading');
		},
		error: function (response) {
			console.log(response);
			btn.removeClass('loading');
		}
	});

	return true;

});




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LIVE LESSON COUNTDOWN
const timer = $('[data-lesson-expiry]');

$(function () {
	if (timer.length) {
		var expiryTimestamp = parseInt(timer.data('lesson-expiry'));
		var lessonUID = timer.data('lesson-uid');
		// startTimer(expiryTimestamp, lessonUID);
		setInterval(function() {
			console.log('CHECK')
			checkTimer(lessonUID);
		}, 60000); // Update once a minute
	}
});



///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CHECK TIMER

window.checkTimer = async function checkTimer(uid) {
	if (!timer.length) {
		return false;
	}

	console.log('CHECK TIMER for ' + uid)

	var requestURL = siteUrl + '/timer/' + uid + '.json';

	console.log('Fetching TIMER data...');
	console.log(requestURL)

	try {
		const response = await $.ajax({
			type: 'get',
			url: requestURL,
		});
		
		console.log(response);
		var expiryTimestamp = response.data[0].expiryDateTimestamp;

		var now = Math.floor(Date.now() / 1000); // Current timestamp in seconds
		var remainingTime = expiryTimestamp - now;
		console.log('remainingTime ' + remainingTime)
		
		if (remainingTime > 0) {
			timer.find('[data-lesson-expiry]').attr('data-lesson-expiry', expiryTimestamp);
			// startTimer(expiryTimestamp, uid);
			var now = Math.floor(Date.now() / 1000); // Current timestamp in seconds
			var remainingTime = expiryTimestamp - now;

			if (remainingTime <= 0) {

				if ($('body.code').length) {
					timer.html('<span class="heading">Expires in</span><span class="time red">00:00:00</span>');
				} else {

					$('[data-modal-lesson-expired]').attr('data-visible', 'true');
					$('body').attr('data-lesson-expired', 'true');
					timer.html('00:00:00');
				}
			} else {
				
				var formattedTime = window.getFormattedTime(remainingTime);

				// Update the HTML element
				timer.find('.time').html(formattedTime);

				if (remainingTime <= 3600) { // 3600 seconds = 1 hour
					$('.time').addClass('red');
				} else {
					$('.time').removeClass('red');
				}

			}
		} else {
			if ($('body.code').length) {
				timer.html('<span class="heading">Expires in</span><span class="time red">00:00:00</span>');
			} else {
				$('[data-modal-lesson-expired]').attr('data-visible', 'true');
				$('body').attr('data-lesson-expired', 'true');
			}
		} 


	} catch (error) {
		console.log('Error fetching TIMER data');
		console.log(error);
	}

	return true;

}

$(document).on('click', 'body.quiz .btn', function(e) {
	var lessonUID = window.parent.$('[data-lesson-expiry]').data('lesson-uid');
	window.parent.checkTimer(lessonUID);
});

$(document).on('click', '[data-quiz-iframe-show]', function(e) {
	console.log('ONE')
 
	var lessonUID = $(this).data('lesson-uid');

	var showNotification = $(this).attr('data-show-notificaion');
	if (showNotification === 'true' && !localStorage.getItem('quizNotificationDisplayed-' + lessonUID)) {
		$('[data-modal-quiz-notification]').attr('data-visible', 'true');
		return false;
	}

	var checked = $('[data-modal-quiz-notification] #dontShowAgainQuiz-' + lessonUID).is(':checked');
	if (checked) {
		localStorage.setItem('quizNotificationDisplayed-' + lessonUID, 'true');
	}

	$('[data-modal-quiz-notification]').attr('data-visible', 'false');
	checkTimer(lessonUID);
	countAttempt();
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EXTEND TIMER
var data = {};

$(document).on('click', '[data-extend-timer]', function(e) {
	var timerBtn = $(this);
	var uid = timerBtn.attr('data-lesson-uid');
	data['uid'] = uid;
	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
	console.log(data)

	timerBtn.text('Extended');
	timerBtn.addClass('extended');

	$.ajax({
		type: 'post',
		url: '/actions/lesson/lesson/extend-timer',
		data: data,
		success: function (response) {
			console.log(response);
			var success = response.success;
			if (success) {
				console.log('y')
				var newExpiry = response.expiryDate;

				if ($('body.account').length) {
					// clearInterval(countdownInterval);
					// countdownInterval = 0;
					var postAction = timerBtn.attr('data-post-action');
					if (postAction == 'refresh-live-lessons') {
						fetchLiveLessonsData();
					}
				} else {
					checkTimer(uid);
					// timerBtn.parent().find('[data-lesson-expiry]').attr('data-lesson-expiry', newExpiry);
					// stop previous timer and trigger new
					// clearInterval(countdownInterval);
					// countdownInterval = 0;
					// startTimer(newExpiry, uid);
				}

			} else {
				console.log('n')
			}
		},
		error: function (response) {
			console.log(response);
		}
	});

	return true;

});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FINISH LESSON
var data = {};
$(document).on('click', '[data-finish-lesson]', function(e) {
	var btn = $(this);
	var uid = btn.attr('data-lesson-uid');
	data['uid'] = uid;
	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
	console.log(data)
	$.ajax({
		type: 'post',
		url: '/actions/lesson/lesson/finish-lesson',
		data: data,
		success: function (response) {
			console.log(response);
			var success = response.success;
			if (success) {
				console.log('y')
				if ($('body.account').length) {
					var postAction = btn.attr('data-post-action');
					if (postAction == 'refresh-page') {
						location.reload();
					}
					if (postAction == 'refresh-recent-lessons') {
						fetchRecentLessonsData('mini');
					}
					var gridEl = btn.closest('.lesson-grid');
					btn.closest('.lesson-row').remove();
					var rowsLeft = gridEl.find('.lesson-row').length;
					console.log('rowsLeft ' + rowsLeft)
					if (rowsLeft == 0) {
						var row = `
							<div class="lesson-row">
								<div class="col col-9">Nothing found.</div>
							</div>
						`;
						gridEl.append(row);
					}
				} else {
					// window.location.href = '/account/results/' + uid;
					$('[data-modal-lesson-expired]').attr('data-visible', 'true');
					$('body').attr('data-lesson-expired', 'true');
	
					// stop previous timer
					// clearInterval(countdownInterval);
					// countdownInterval = 0;
				}
			} else {
				console.log('n')
			}
		},
		error: function (response) {
			console.log(response);
		}
	});

	return true;

});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// STUDENT LOGIN
$(document).on('submit', '[data-student-login]', async function(e) {
	var startTime = performance.now(); // Record the start time

	e.preventDefault();

	var btnEl = $(this).find('button');
	var codeNoticeEl = $('.student-login-notices-code');
	var firstNameNoticeEl = $('.student-login-notices-firstName');
	var lastNameNoticeEl = $('.student-login-notices-lastName');
	var generalNoticeEl = $('.student-login-notices-general');

	// Validation flags
	var isValid = true;

	// Extract values from serialized data
	var codeEl = $(this).find("[name='code']");
	var codeVal = codeEl.val();
	codeVal = $.trim(codeVal);
	if (!/^\d{6}$/.test(codeVal)) {
		isValid = false;
		codeEl.addClass('border-incorrect');
		codeNoticeEl.text("Code must be a 6-digit number.");
		console.log("Code must be a 6-digit number.");
	} else {
		codeEl.removeClass('border-incorrect');
		codeNoticeEl.text("");
	}

	var firstNameEl = $(this).find("[name='firstName']");
	var firstNameVal = firstNameEl.val();
	firstNameVal = $.trim(firstNameVal);
	if (firstNameVal === "") {
		isValid = false;
		firstNameEl.addClass('border-incorrect');
		firstNameNoticeEl.text("First Name cannot be empty.");
		console.log("First Name cannot be empty.");
	} else {
		firstNameEl.removeClass('border-incorrect');
		firstNameNoticeEl.text("");
	}

	var lastNameEl = $(this).find("[name='lastName']");
	var lastNameVal = lastNameEl.val();
	lastNameVal = $.trim(lastNameVal);
	if (lastNameVal === "") {
		isValid = false;
		lastNameEl.addClass('border-incorrect');
		lastNameNoticeEl.text("Last Name cannot be empty.");
		console.log("Last Name cannot be empty.");
	} else {
		lastNameEl.removeClass('border-incorrect');
		lastNameNoticeEl.text("");
	}

	// If any validation errors, display them and prevent form submission
	if (!isValid) {
		return false; // Prevent form submission
	}

	btnEl.text('Connecting')
	btnEl.addClass('processing')

	var data = $(this).serialize();
	console.log(data)

	try {
		var response = await $.ajax({
			type: 'post',
			url: '/actions/lesson/student/student-login',
			data: data
		});

		console.log(response);
		var success = response.success;
		if (success) {
			console.log('y');

			var endTime = performance.now(); // Record the end time
			var duration = (endTime - startTime) / 1000; // Calculate the duration in seconds
		
			console.log('LOGIN TOOK = ' + duration);

			if (dataLayer) {
				dataLayer.push({
					'event': 'student_login',
					'lessonCode': response.lessonCode
				});
			}

			window.location.href = response.url;
		} else {
			console.log('n');
			generalNoticeEl.text("Lesson not found.");
			btnEl.text("Let's go!");
			btnEl.removeClass('processing');
		}
	} catch (error) {
		console.log(error);
		generalNoticeEl.text("An error occurred.");
		btnEl.text("Let's go!");
		btnEl.removeClass('processing');
	}

	return true;

});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// STUDENT LOGOUT
var data = {};
$(document).on('click', '[data-lesson-exit-confirm]', function(e) {
	e.preventDefault();
	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
	console.log(data)
	$.ajax({
		type: 'post',
		url: '/actions/lesson/student/student-logout',
		data: data,
		success: function (response) {
			console.log(response);
			var success = response.success;
			if (success) {
				console.log('y')
				window.location.href = '/';
				// $('[data-modal-lesson-expired]').attr('data-visible', 'true');
				// $('body').attr('data-lesson-expired', 'true');
			} else {
				console.log('n')
			}
		},
		error: function (response) {
			console.log(response);
		}
	});

	return true;

});

$(document).on('click', '[data-student-logout]', function(e) {
	console.log('data-student-logout')

	$('[data-lesson-exit-message]').attr('data-visible', 'true');
	window.parent.$('[data-lesson-exit-message]').attr('data-visible', 'true');

	return false;
});

$(document).on('click', '[data-lesson-exit-cancel]', function(e) {
	console.log('data-lesson-exit-cancel hide')

	$('[data-lesson-exit-message]').attr('data-visible', 'false');

	return false;
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// COPY LIVE CODE
$(document).on('click', '[data-copy-code]', function(e) {
	var el = $(this);
	var code = el.attr('data-copy-code');
	
	var tempInput = document.createElement('input');
	tempInput.setAttribute('value', code);
	document.body.appendChild(tempInput);
	tempInput.select();
	document.execCommand('copy');
	document.body.removeChild(tempInput);

	return true;

});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// COPY EMAIL TEXT
$(document).on('click', '[data-copy-email]', function(e) {
	var btn = $(this);
	var code = btn.attr('data-copy-code');
	var popup = $('.lesson-code');
	var tempInput = document.createElement('textarea');
	var teacherName = popup.find('.teacher span').text();
	var lessonName = popup.find('.name').text().replace('\n', ' ');
	var code = popup.find('.code-block .code span').text();
	// var instructions = popup.find('.instructions').text();
	var emailBody = teacherName + ` has invited you to complete the lesson: ` + lessonName + `.\nCode: ` + code + `\n` + `Head to https://learn.sciencealive.co.nz and enter the code to get started!`;
	console.log(emailBody)
	// tempInput.setAttribute('value', emailBody);
	tempInput.innerHTML = emailBody;
	document.body.appendChild(tempInput);
	tempInput.select();
	document.execCommand('copy');
	document.body.removeChild(tempInput);

	btn.text('Copied!');

	setTimeout(() => {
		btn.text('Copy information');
	}, 1500);

	return true;

});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ACCORDION

$(document).on('click', '.accordion:not(.is-open)', function(e) {
	$(this).addClass('is-open');
	var content = $(this).parent().find('.accordion-content');
	var maxH = content.find('div').outerHeight() + 40;
	content.css('max-height', maxH);
});
$(document).on('click', '.accordion.is-open', function(e) {
	$(this).removeClass('is-open');
	var content = $(this).parent().find('.accordion-content');
	content.removeAttr('style');
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FORMATTED TIME

window.getFormattedTime = function getFormattedTime(remainingTime) {
	var days = Math.floor(remainingTime / (24 * 3600));
	var hours = Math.floor((remainingTime % (24 * 3600)) / 3600);
	var minutes = Math.floor((remainingTime % 3600) / 60);
	
	var formattedTime = '';
	
	if (days > 0) {
		formattedTime += days + (days === 1 ? ' day ' : ' days ');
	}
	
	if (hours > 0 || days > 0) {
		formattedTime += hours + (hours === 1 ? ' hour ' : ' hours ');
	}
	
	if (days === 0 && hours < 24) {
		formattedTime += minutes + ' min';
	}

	return formattedTime;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




// MENU

$('.btn-menu-mobile').on("click", function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
	var mobMenu = $('aside.mobile-menu');
	if ($(this).hasClass('open')) {
		$('body').attr('mobile-aria-expanded', true);
		mobMenu.attr('aria-expanded', true);
	} else {
		$('body').attr('mobile-aria-expanded', false);
		mobMenu.attr('aria-expanded', false);
	}
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BLITZ INJECT

document.addEventListener('afterBlitzInject', function (event) { 
	console.log('app.js afterBlitzInject')

	// QUIZES IN LESSONS
	var quizBlocks = $('.quiz-block');
	quizBlocks.each(function() {
		var uid = $(this).attr('data-quiz');
		fetchQuizData(uid, 'quiz-preview');
	})

	// AUDIO
	pollyPlayButtonInit();


	

});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// COPY SHARE LINK
$(document).on('click', '[data-share]', function(e) {
	var el = $(this);
	var url = el.attr('data-lesson-url');
	
	var tempInput = document.createElement('input');
	tempInput.setAttribute('value', url);
	document.body.appendChild(tempInput);
	tempInput.select();
	document.execCommand('copy');
	document.body.removeChild(tempInput);

	el.find('.copy-success').show();

	setTimeout(() => {
		el.find('.copy-success').hide();
	}, 1500);

	return true;

});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LESSON and QUIZ NOTIFICATIONS
$(document).ready(function() {
	var lessonUID = $('[data-modal-lesson-notification] [data-modal-lesson-dismiss][data-lesson-uid]').attr('data-lesson-uid');
	if (!localStorage.getItem('lessonNotificationDisplayed-' + lessonUID)) {
		$('[data-modal-lesson-notification]').attr('data-visible', 'true');
	}
});
$(document).on('click', '[data-modal-lesson-dismiss]', function(e) {
	var lessonUID = $(this).data('lesson-uid');
	var checked = $('[data-modal-lesson-notification] #dontShowAgainLesson-' + lessonUID).is(':checked');
	if (checked) {
		localStorage.setItem('lessonNotificationDisplayed-' + lessonUID, 'true');
	}
	$('[data-modal-lesson-notification]').attr('data-visible', 'false');
});
$(document).on('click', '[data-modal-quiz-dismiss]', function(e) {
	var lessonUID = $(this).data('lesson-uid');
	var checked = $('[data-modal-quiz-notification] #dontShowAgainQuiz-' + lessonUID).is(':checked');
	if (checked) {
		localStorage.setItem('quizNotificationDisplayed-' + lessonUID, 'true');
	}
	$('[data-modal-quiz-notification]').attr('data-visible', 'false');
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EDIT BUTTON FOR ADMINS ONLY

$(function () {
	fetchUserAccess();
});
async function fetchUserAccess() {
	var page = window.page;
	if (!page) return false;
	try {
		const response = await $.ajax({
			type: 'get',
			url: '/dynamic/admin?page=' + page,
		});
		if (response) {
			var url = response;
			var newUrl;
			if (url.includes('site=')) {
				newUrl = url + '&ni-block=';
			} else {
				newUrl = url + '?ni-block=';
			}
			var btn = `
				<a class="btn btn-yellow btn-fill btn-edit" href="` + newUrl + `" target="_blank">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.424 12.282l4.402 4.399-5.826 1.319 1.424-5.718zm15.576-6.748l-9.689 9.804-4.536-4.536 9.689-9.802 4.536 4.534zm-6 8.916v6.55h-16v-12h6.743l1.978-2h-10.721v16h20v-10.573l-2 2.023z"/></svg>
				</a>
			`;

			$('main').append(btn);
			
			// var sections = document.querySelectorAll('[data-ni-block-id]');
			// sections.forEach(function (section) {
			// 	var niBlock = section.getAttribute('data-ni-block-id');
			// 	var link = document.createElement('a');
			// 	link.className = 'aria bg-purple-300 py-1 px-1 rounded-full absolute top-2 right-2 text-14 z-10 flex items-center';
			// 	link.href = newUrl + niBlock + '#tab03--live-lesson';
			// 	link.target = '_blank';
			// 	link.innerHTML = '<svg class="w-4" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z" fill-rule="nonzero" fill="currentColor"/></svg>';
			// 	section.appendChild(link);
			// });
		}
	} catch (error) {
		console.log('fetchUserAccess() error');
		console.log(error);
	}
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// YOUTUBE PLAYER

var playersYoutube = [];
var playerIdsYoutube = [];
var playersVimeo = [];
var playerIdsVimeo = [];

$(function () {
	youtube();
	vimeo();
	amazon();
});

function collectPlayerIdsYoutube() {
	$('iframe[id^="youtube"]').each(function() {
		var id = $(this).attr('id');
		playerIdsYoutube.push(id);
	});
}

function collectPlayerIdsVimeo() {
	if (!$('iframe[id^="vimeo"]').length) return false;
	$('iframe[id^="vimeo"]').each(function() {
		var id = $(this).attr('id');
		playerIdsVimeo.push(id);
	});
}

function youtube() {
	if (!$('iframe[id^="youtube"]').length) return false;
	collectPlayerIdsYoutube();
	window.YT.ready(function() {
		console.log('YT ready')
		playerIdsYoutube.forEach(function(id) {
			var player = new YT.Player(id, {
				events: {
					'onStateChange': onPlayerStateChange
				},
				playerVars: {
					origin: window.location.origin
				},
				host: 'https://www.youtube.com',
			});
			playersYoutube.push(player);
		});
	})
}

function onPlayerStateChange(event) {
	if (event.data == YT.PlayerState.PLAYING) {
		console.log('Video is playing');
		console.log($(event.target.g).parent())
		$(event.target.g).parent().find('.video-block-overlay').hide();
	} else if (event.data == YT.PlayerState.PAUSED) {
		console.log('Video is paused');
	} else if (event.data == YT.PlayerState.ENDED) {
		$(event.target.g).parent().find('.video-block-overlay').show();
		console.log('Video ended');
	}
}

function vimeo() {
    collectPlayerIdsVimeo();
	console.log(playerIdsVimeo)
    playerIdsVimeo.forEach(function(id) {
      var iframe = document.getElementById(id);
      var player = new Vimeo.Player(iframe);

      player.on('play', function() {
        console.log('Video is playing');
        $(iframe).parent().find('.video-block-overlay').hide();
      });

      player.on('pause', function() {
        console.log('Video is paused');
      });

      player.on('ended', function() {
        $(iframe).parent().find('.video-block-overlay').show();
        console.log('Video ended');
      });

      playersVimeo.push(player);
    });
}

function amazon() {
	// Select all video elements
	$('video[id^="amazon"]').each(function() {
		var video = this; // `this` refers to the video element
		var $video = $(video); // jQuery object for easier manipulation

		// Event listeners for the video element
		$video.on('play', function() {
			console.log('Video is playing');
			$video.parent().find('.video-block-overlay').hide(); // Hide overlay
		});

		$video.on('pause', function() {
			console.log('Video is paused');
		});

		$video.on('ended', function() {
			console.log('Video ended');
			$video.parent().find('.video-block-overlay').show(); // Show overlay
		});
	});
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LESSON COMPONENT - ZOOM IN OUT

$(document).ready(function() {
	// Only initialize if zoom blocks exist on the page
	if ($('.zoom-block').length === 0) return;

	// For each zoom block on the page
	$('.zoom-block').each(function() {
		const $zoomBlock = $(this);
		const $zoomPanel = $(this).find('.zoom-panel');

		// Count how many zoom levels we have
		const zoomLevels = 6;

		// Create controls element
		const $controls = $('<div class="zoom-controls"></div>');

		// Create zoom out button
		const $zoomOutBtn = $('<button class="zoom-button zoom-out" aria-label="Zoom out"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="59" viewBox="0 0 56 57"><g transform="translate(-0.118 57.373) rotate(-90)"><g transform="translate(0.373 0.118)" fill="rgba(119,119,119,0.5)" stroke="currentColor" stroke-width="2"><rect width="57" height="56" rx="6" stroke="none"/><rect x="1" y="1" width="55" height="54" rx="5" fill="none"/></g><line y2="24.697" transform="translate(28.727 40.661) rotate(180)" fill="none" stroke="currentColor" stroke-width="3"/></g></svg></button>');

		// Create zoom level buttons
		const $zoomLevels = $('<div class="zoom-levels"></div>');
		for (let i = 1; i <= zoomLevels; i++) {
			const $levelBtn = $(`<button class="zoom-level-button ${i === zoomLevels ? 'active' : ''}" data-level="${i}" aria-label="Zoom level ${i}" ${i === zoomLevels ? 'aria-current="true"' : ''}></button>`);
			$zoomLevels.append($levelBtn);
		}

		// Create zoom in button
		const $zoomInBtn = $('<button class="zoom-button zoom-in" aria-label="Zoom in" disabled><svg xmlns="http://www.w3.org/2000/svg" width="56" height="59" viewBox="0 0 56 57"><g transform="translate(-0.118 57.357) rotate(-90)"><g transform="translate(0.357 0.118)" fill="rgba(119,119,119,0.5)" stroke="currentColor" stroke-width="2"><rect width="57" height="56" rx="6" stroke="none"/><rect x="1" y="1" width="55" height="54" rx="5" fill="none"/></g><g transform="translate(40.807 15.964) rotate(90)"><line y2="24.697" transform="translate(12.349 0)" fill="none" stroke="currentColor" stroke-width="3"/><line y2="24.697" transform="translate(24.697 12.349) rotate(90)" fill="none" stroke="currentColor" stroke-width="3"/></g></g></svg></button>');

		// Add all controls
		$controls.append($zoomInBtn);
		$controls.append($zoomLevels);
		$controls.append($zoomOutBtn);

		// Add controls to the zoom block
		$zoomPanel.append($controls);

		// Keep track of current zoom level
		let currentZoomLevel = 6;

		// Function to change zoom level with blur transition
		function changeZoomLevel(newLevel) {
			if (newLevel < 1 || newLevel > zoomLevels) return;

			// Update zoom in/out button states
			$zoomOutBtn.prop('disabled', newLevel === 1);
			$zoomInBtn.prop('disabled', newLevel === zoomLevels);

			// Early return if already at this level
			if (newLevel === currentZoomLevel) return;

			// Add blur effect to current image
			const $image = $zoomBlock.find(`.zoom-image[data-zoomlevel]`);
			// $image.addClass('blurry');

			// Wait for blur transition, then switch images
			setTimeout(function() {
				// Hide all images
				// $zoomBlock.find('.zoom-image').removeClass('active');

				// Update level buttons
				$zoomLevels.find('.zoom-level-button').removeClass('active').attr('aria-current', 'false');
				$zoomLevels.find(`.zoom-level-button[data-level="${newLevel}"]`).addClass('active').attr('aria-current', 'true');

				// Show new image with blur
				const $newImage = $zoomBlock.find(`.zoom-image[data-zoomlevel]`).attr('data-zoomlevel', newLevel);
				// $newImage.addClass('active blurry');

				// Remove blur after transition
				setTimeout(function() {
					// $newImage.removeClass('blurry');
					currentZoomLevel = newLevel;
				}, 150);
			}, 150);
		}

		// Handle zoom in button click
		$zoomInBtn.on('click', function() {
			changeZoomLevel(currentZoomLevel + 1);
		});

		// Handle zoom out button click
		$zoomOutBtn.on('click', function() {
			changeZoomLevel(currentZoomLevel - 1);
		});

		// Handle zoom level button clicks
		$zoomLevels.on('click', '.zoom-level-button', function() {
			const newLevel = parseInt($(this).data('level'), 10);
			changeZoomLevel(newLevel);
		});
	});
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CLASSROOM VIEW
var data = {};
$(document).on('click', '[data-mini-lesson-view]', function(e) {
	var btn = $(this);
	var view = btn.attr('data-mini-lesson-view');
	if (view != 'normal' && view != 'classroom') {
		view = 'normal';
	}
	if (view == 'classroom') {
		$('body').attr('data-classroom-view', 'true');
	} else {
		$('body').attr('data-classroom-view', 'false');
	}
	var section = btn.closest('section');
	section.attr('data-view', view);
	return true;
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////